function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "master_plan");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  width: 972,
  height: 619,
  fill: "#3f3d56"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 88,
  cy: 103,
  r: 14,
  fill: "#f2f2f2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 427,
  cy: 54,
  r: 14,
  fill: "#f2f2f2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 418,
  cy: 276,
  r: 25,
  fill: "#f2f2f2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 333,
  cy: 62,
  r: 6,
  fill: "#ff6584"
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 63,
  cy: 303,
  r: 6,
  fill: "#ff6584"
});

var _ref9 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 894,
  cy: 316,
  r: 6,
  fill: "#ff6584"
});

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 240,
  cy: 196,
  r: 6,
  fill: "#f2f2f2"
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 900,
  cy: 62,
  r: 6,
  fill: "#f2f2f2"
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 88,
  cy: 487,
  r: 6,
  fill: "#f2f2f2"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 810,
  cy: 429,
  r: 6,
  fill: "#f2f2f2"
});

var _ref14 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 636,
  cy: 56,
  r: 6,
  fill: "#f2f2f2"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M843,250.49288a15,15,0,1,1,15-15A15.01672,15.01672,0,0,1,843,250.49288Zm0-28a13,13,0,1,0,13,13A13.01474,13.01474,0,0,0,843,222.49288Z",
  transform: "translate(-114 -81.49288)",
  fill: "#f2f2f2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M815,288.49288a11,11,0,1,1,11-11A11.01245,11.01245,0,0,1,815,288.49288Zm0-20a9,9,0,1,0,9,9A9.01016,9.01016,0,0,0,815,268.49288Z",
  transform: "translate(-114 -81.49288)",
  fill: "#f2f2f2"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M877,341.49288a11,11,0,1,1,11-11A11.01245,11.01245,0,0,1,877,341.49288Zm0-20a9,9,0,1,0,9,9A9.01016,9.01016,0,0,0,877,321.49288Z",
  transform: "translate(-114 -81.49288)",
  fill: "#f2f2f2"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M857,356.49288a82,82,0,1,1,82-82A82.093,82.093,0,0,1,857,356.49288Zm0-162a80,80,0,1,0,80,80A80.09041,80.09041,0,0,0,857,194.49288Z",
  transform: "translate(-114 -81.49288)",
  fill: "#f2f2f2"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M857,307.49288c-68.41113,0-122-14.49511-122-33,0-10.78271,15.90527-20.04834,44.78613-26.09033l.41016,1.958C752.74414,256.10324,737,264.89913,737,274.49288c0,16.80372,54.95313,31,120,31s120-14.19628,120-31c0-9.61181-15.79785-18.41894-43.34277-24.16308l.4082-1.958C963.042,254.41476,979,263.69113,979,274.49288,979,292.99777,925.41113,307.49288,857,307.49288Z",
  transform: "translate(-114 -81.49288)",
  fill: "#f2f2f2"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M795.441,624.70922c-2.77441,0-5.57715-.04394-8.32812-.12988l.0625-1.99805c3.95019.12305,7.98144.15723,11.95019.10254l.02735,2Q797.29987,624.70873,795.441,624.70922Zm15.74512-.46387-.11719-1.99609c3.95606-.2334,7.96289-.56152,11.90918-.97461l.209,1.98828C819.21052,623.67992,815.17341,624.011,811.18611,624.24535Zm-36.0957-.31152c-3.98926-.30566-8.02051-.706-11.98243-1.19238l.24414-1.98438c3.93164.48145,7.93164.87989,11.89063,1.18262Zm60.03906-2.19922-.29981-1.97656c3.93067-.59668,7.8916-1.28906,11.76953-2.05957l.38965,1.96094C843.08064,620.43578,839.09041,621.134,835.12947,621.73461Zm-83.93506-.73144c-3.94092-.668-7.91895-1.43555-11.82324-2.28321l.42431-1.95507c3.87452.84179,7.82178,1.60351,11.73291,2.26562Zm107.54834-3.96192-.48047-1.9414c3.8584-.95411,7.73828-2.00879,11.53223-3.13379l.56836,1.918C866.53962,615.01782,862.63044,616.08032,858.74275,617.04125Zm-131.07617-1.14648c-3.86573-1.02832-7.75586-2.15918-11.5625-3.36328l.60254-1.90625c3.77783,1.19433,7.63818,2.3164,11.47363,3.33593Zm154.1582-5.70117-.65625-1.88868c3.74414-1.30175,7.50977-2.709,11.19434-4.18359l.74218,1.85742C889.39314,607.4641,885.59822,608.88207,881.82478,610.1936Zm-177.14551-1.56641c-3.75439-1.37988-7.53222-2.86914-11.22754-4.42578l.77637-1.84375c3.667,1.54492,7.41553,3.02246,11.1416,4.39258ZM904.15388,601.259l-.82812-1.82032c3.5957-1.63379,7.21-3.37793,10.74218-5.18359l.91016,1.78125C911.41853,597.85571,907.77693,599.61254,904.15388,601.259Zm-221.71045-1.99414c-3.60888-1.71973-7.23144-3.54883-10.76562-5.4375l.94238-1.76368c3.50781,1.874,7.10205,3.68946,10.68359,5.39649Zm243.10889-8.94434-.99023-1.73633c3.44824-1.96777,6.89062-4.03613,10.22949-6.14844l1.06836,1.68946C932.49568,586.25414,929.02791,588.3391,925.55232,590.32055Zm-264.376-2.418c-3.43261-2.042-6.87011-4.19531-10.21631-6.39941l1.10059-1.66993c3.32031,2.1875,6.73145,4.32422,10.13818,6.35059Zm284.69922-10.43945-1.14453-1.63867c3.24707-2.26856,6.48731-4.64454,9.63086-7.06055l1.21875,1.58594C952.41365,572.78442,949.148,575.178,945.87556,577.46313Zm-304.82568-2.81641c-3.228-2.34473-6.45264-4.80078-9.585-7.30176l1.248-1.5625c3.1084,2.48145,6.3086,4.91895,9.51172,7.24512ZM964.95271,562.801l-1.28906-1.5293c3.02636-2.55371,6.03808-5.21484,8.95312-7.91015l1.35742,1.46875C971.03767,557.54614,968.00251,560.22778,964.95271,562.801Zm-342.728-3.18555c-3.00634-2.63281-5.99316-5.37109-8.877-8.13965l1.38477-1.44336c2.8623,2.74805,5.82617,5.46582,8.80957,8.07911Zm360.40088-13.16113-1.42383-1.4043c2.79-2.82715,5.54981-5.75293,8.20118-8.69531l1.48632,1.33789C988.21736,540.65844,985.43709,543.60571,982.62556,546.45434Zm-377.77295-3.51172c-2.7583-2.90039-5.48242-5.89844-8.09668-8.91016l1.51075-1.31054c2.59423,2.98925,5.29736,5.96386,8.03515,8.84179Zm393.89307-14.37988-1.54492-1.26953c2.5205-3.06739,5.002-6.23243,7.37793-9.40918l1.60156,1.19726C1003.78669,522.28246,1001.28572,525.47289,998.74568,528.56274Zm-409.6709-3.79688c-2.47705-3.12988-4.916-6.36133-7.24951-9.60449l1.623-1.168c2.31591,3.21777,4.73632,6.42481,7.19482,9.53223Zm424.09961-15.49707-1.6543-1.12305c2.23047-3.28417,4.415-6.66406,6.49219-10.04785l1.70508,1.04688C1017.62263,502.554,1015.42146,505.9602,1013.17439,509.26879Zm-438.15088-4.0293c-2.1792-3.34082-4.312-6.77832-6.33984-10.21972l1.72265-1.01563c2.0127,3.415,4.1294,6.82715,6.292,10.1416Zm450.76611-16.51074-1.75-.96679c1.91993-3.47461,3.78516-7.043,5.5459-10.60645l1.793.88672C1029.605,481.63207,1027.72419,485.22778,1025.78962,488.72875Zm-462.9707-4.20508c-1.86523-3.52539-3.67383-7.14257-5.37549-10.75l1.8086-.85351c1.689,3.58008,3.4834,7.16992,5.33447,10.668Zm473.65137-17.416-1.832-.80274c1.59375-3.63964,3.124-7.36718,4.54883-11.07812l1.86718.7168C1039.61873,459.68383,1038.07576,463.43969,1036.47029,467.10766Zm-483.90235-4.31543c-1.5332-3.67969-3.00146-7.44434-4.36376-11.19043l1.87988-.68359c1.35156,3.71777,2.80859,7.45312,4.32959,11.10449Zm492.55079-18.21582-1.89844-.62891c1.248-3.76074,2.42578-7.60449,3.5-11.42578l1.92578.541C1047.56306,436.91332,1046.37556,440.78735,1045.11873,444.57641ZM544.35164,440.1936c-1.18995-3.81153-2.30811-7.70508-3.32325-11.57422l1.93457-.50781c1.00733,3.83984,2.11719,7.7041,3.29786,11.48632Zm507.28564-18.79493-1.94824-.45312c.89551-3.85449,1.71387-7.791,2.43359-11.69824l1.9668.36133C1053.36482,413.54711,1052.53962,417.51293,1051.63728,421.39867Zm-513.394-4.49414c-.834-3.90625-1.58887-7.88574-2.24317-11.83007l1.97266-.32813c.6499,3.915,1.39893,7.86426,2.22656,11.74024Zm517.75244-19.18359-1.98242-.27148c.53808-3.917.99218-7.91114,1.35058-11.87207l1.99219.17968C1056.9947,389.74926,1056.53669,393.77367,1055.99568,397.72094Zm-521.69385-4.56641c-.47168-3.959-.85889-7.99121-1.15137-11.98437l1.99512-.14649c.28955,3.96387.67432,7.96485,1.14258,11.89454Zm523.86865-19.40918-1.998-.08984c.17773-3.96289.26855-7.98242.26855-11.94629h2C1058.441,365.70336,1058.35017,369.75317,1058.17048,373.74535Zm-525.626-4.60156c-.06836-2.45215-.103-4.9541-.10352-7.43457q0-2.30859.03955-4.6084l2,.03516q-.03954,2.28222-.03955,4.57324c.00049,2.46192.03516,4.94531.10254,7.37988Zm523.88183-10.22461c-.041-3.96533-.17383-7.98437-.39355-11.94629l1.99609-.11132c.22168,3.99218.35547,8.0415.39746,12.03613ZM534.95515,345.196l-1.99609-.125c.24951-3.9961.59424-8.03223,1.02344-11.99658l1.98828.21533C535.54451,337.22436,535.2032,341.22973,534.95515,345.196Zm520.14209-10.13477c-.39941-3.94287-.89648-7.93213-1.47656-11.85791l1.97851-.292c.584,3.95557,1.085,7.9751,1.48829,11.94775ZM537.52791,321.44311l-1.97657-.30567c.6128-3.95654,1.32471-7.94433,2.11621-11.854l1.96.39648C538.84236,313.55981,538.13582,317.51733,537.52791,321.44311Zm514.07421-10.01563c-.76269-3.90136-1.623-7.82861-2.55859-11.67236l1.94336-.47266c.94238,3.873,1.80957,7.83057,2.57812,11.76123ZM542.26521,298.02612l-1.93994-.48633c.97119-3.87354,2.04687-7.7793,3.19726-11.60938l1.915.5752C544.29646,290.30639,543.22908,294.18237,542.26521,298.02612Zm503.68457-9.81348c-1.11523-3.80811-2.334-7.63867-3.62207-11.38672l1.89063-.65039c1.29882,3.77686,2.52734,7.6377,3.65136,11.47461ZM549.15,275.11254l-1.88672-.66308c1.3291-3.78077,2.76416-7.57959,4.26513-11.291l1.8545.75C551.89314,267.59106,550.46882,271.36108,549.15,275.11254Zm489.0332-9.49463c-1.459-3.68066-3.02149-7.37451-4.64453-10.97949l1.82422-.82129c1.63574,3.63281,3.21,7.355,4.67968,11.06348ZM558.12654,252.91528l-1.81738-.835c1.67041-3.6377,3.44824-7.28565,5.28418-10.84229l1.77734.917C561.54841,245.68481,559.78425,249.30492,558.12654,252.91528Zm470.26855-9.03565c-1.79-3.53076-3.68652-7.06885-5.63672-10.51465l1.74024-.98535c1.96582,3.47266,3.876,7.0376,5.67969,10.5957Zm-459.2915-12.22949-1.7334-.99805c1.99512-3.46435,4.09912-6.93213,6.25391-10.30615l1.68554,1.07617C573.17146,224.77074,571.08308,228.21215,569.10359,231.65014Zm447.5415-8.53516c-2.11328-3.36425-4.32617-6.71582-6.57715-9.96191l1.64258-1.13965c2.26856,3.271,4.499,6.648,6.62793,10.03809ZM581.97664,211.49145l-1.63477-1.15235c2.30566-3.27,4.71631-6.52929,7.1665-9.6875l1.58008,1.22559C586.6573,205.012,584.26423,208.24633,581.97664,211.49145Zm421.064-7.99219c-2.41016-3.15674-4.91992-6.29492-7.46191-9.32715l1.5332-1.28467c2.56055,3.05567,5.08984,6.21729,7.51855,9.398ZM596.63,192.60033l-1.52246-1.29687c2.5874-3.03906,5.28418-6.064,8.01513-8.99072l1.46192,1.36425C601.87459,186.58178,599.19832,189.58422,596.63,192.60033Zm391.06982-7.4082c-2.68652-2.92431-5.47363-5.82275-8.28223-8.61377l1.41016-1.41894c2.83008,2.813,5.6377,5.73291,8.34473,8.6792Zm-374.76514-10.064-1.39843-1.42969c2.85986-2.79785,5.81933-5.564,8.79541-8.22119l1.332,1.49219C618.71,169.60619,615.773,172.35131,612.93464,175.12817Zm357.81787-6.77979c-2.94433-2.67041-5.98437-5.3042-9.03515-7.82812l1.27539-1.541c3.07324,2.543,6.13672,5.19678,9.10351,7.8877ZM630.753,159.21655l-1.26269-1.55079c3.09326-2.519,6.29-5.00341,9.50195-7.38427l1.19141,1.60644C636.99568,154.25121,633.82283,156.71655,630.753,159.21655Zm321.58155-6.10694c-3.17676-2.39209-6.44532-4.73926-9.71485-6.97607l1.12891-1.65039c3.29492,2.25342,6.58789,4.61816,9.78906,7.02881Zm-302.39942-8.11035-1.11621-1.65918c3.31055-2.22754,6.71875-4.40869,10.13037-6.48437l1.03906,1.709C656.6031,140.62426,653.22078,142.7893,649.93513,144.99926Zm282.65918-5.39111c-3.37988-2.0918-6.85058-4.13086-10.31543-6.06153l.97266-1.74707c3.49219,1.94532,6.98926,4.00049,10.39551,6.10743Zm-262.27148-7.01026-.96-1.75488c3.50244-1.9165,7.09375-3.77588,10.67382-5.52734l.87891,1.79687C677.36287,128.85033,673.7989,130.69555,670.32283,132.59789Zm241.37011-4.63379c-3.55859-1.77294-7.2041-3.48584-10.835-5.09082l.8086-1.8291c3.65918,1.61719,7.333,3.34326,10.91894,5.12989ZM691.7447,122.11987l-.79492-1.835c3.66016-1.58643,7.4043-3.10792,11.12793-4.52247l.71,1.87012C699.09236,119.03588,695.377,120.54565,691.7447,122.11987Zm198.05176-3.83448c-3.70312-1.436-7.49316-2.80615-11.26562-4.07177l.63671-1.89649c3.80079,1.27588,7.62012,2.65625,11.35157,4.104ZM714.0533,113.64867l-.62305-1.90039c3.80078-1.24609,7.67871-2.41943,11.52539-3.48632l.53467,1.92675C721.67293,111.2478,717.82478,112.41186,714.0533,113.64867ZM867.11677,110.675c-3.81445-1.0874-7.70508-2.1001-11.56347-3.00976l.459-1.94629c3.88867.9165,7.80859,1.937,11.65332,3.03222Zm-130.0415-3.41553-.44531-1.9497c3.89648-.89014,7.86572-1.70117,11.79687-2.41016l.35547,1.96777C744.88044,105.57153,740.942,106.37621,737.07527,107.25951Zm106.7876-2.06689c-3.89453-.731-7.86133-1.38135-11.791-1.93311l.27734-1.98046c3.96.55615,7.958,1.21142,11.88282,1.94775Zm-83.27539-2.17627-.26465-1.98242c3.959-.52832,7.98535-.97266,11.96679-1.31934l.17383,1.99219C768.51228,102.05151,764.51716,102.49194,760.58748,103.01635Zm59.61621-1.14746c-3.93946-.37109-7.94922-.65723-11.91895-.84912l.09766-1.998c3.999.19385,8.03906.48194,12.00879.856Zm-35.81446-.9292-.084-1.998c3.67578-.15332,7.42187-.23144,11.13574-.23242l.90527.00147-.00585,2-.89942-.00147C791.75544,100.7102,788.03669,100.78783,784.38923,100.93969Z",
  transform: "translate(-114 -81.49288)",
  fill: "#f2f2f2"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M569.914,467.49849c9.36612-11.33011,19.94116-21.9814,32.84781-29.018s28.45465-10.15923,42.54666-5.97461c10.51951,3.12376,19.486,9.99583,27.7843,17.17615,17.002,14.71151,32.67943,31.55515,52.7333,41.72075s46.47774,12.063,63.511-2.6124c13.48079-11.6147,19.22836-31.73232,35.32688-39.31325,15.86939-7.473,34.26972.55161,50.37328,7.50568a421.23122,421.23122,0,0,0,67.648,22.62985c15.65965,3.799,31.791,6.71109,47.83225,5.18329s32.14167-7.9497,42.60416-20.205",
  transform: "translate(-114 -81.49288)",
  fill: "#f2f2f2"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M493.44578,411.2165h40.37653a141.21841,141.21841,0,0,0,0-48.14125H493.44578A86.62233,86.62233,0,0,1,493.44578,411.2165Z",
  transform: "translate(-114 -81.49288)",
  fill: "#6c63ff"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.44578,433.2165h40.37653a141.21841,141.21841,0,0,0,0-48.14125H166.44578A86.62233,86.62233,0,0,1,166.44578,433.2165Z",
  transform: "translate(-114 -81.49288)",
  fill: "#6c63ff"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M869.44578,287.2165h40.37653a141.21841,141.21841,0,0,0,0-48.14125H869.44578A86.62233,86.62233,0,0,1,869.44578,287.2165Z",
  transform: "translate(-114 -81.49288)",
  fill: "#6c63ff"
});

var _ref25 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "206.688 657.431 198.225 684.361 224.385 686.669 222.077 657.431 206.688 657.431",
  fill: "#ffb9b9"
});

var _ref26 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "333.644 678.205 333.644 715.138 363.651 715.138 355.188 678.205 333.644 678.205",
  fill: "#ffb9b9"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M340.69342,491.16841,328.3826,608.12123s-15.38853,103.10315-12.31082,119.26111-.76943,18.46623-.76943,18.46623h23.08279s-.76942-10.00254,3.84714-14.6191,2.30828-18.46624,2.30828-18.46624L403.017,534.25629l33.08534,100.02544s5.386,110.028,6.15541,111.56684,3.0777,22.31337,3.0777,22.31337H473.8042s-3.84713-12.31082,1.53886-16.158,10.00254-.76942,5.386-7.69426-6.15541-15.38853-4.61656-19.23566,1.53886-19.23567,1.53886-19.23567-2.30828-207.74514-15.38853-214.67S340.69342,491.16841,340.69342,491.16841Z",
  transform: "translate(-114 -81.49288)",
  fill: "#2f2e41"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M455.775,777.05655s-13.15652-1.97348-13.15652-1.31565-15.78783,43.41653,0,42.7587,75.65-9.20956,71.70305-24.99739-23.68174-11.183-23.68174-11.183l-17.76131-9.86739Z",
  transform: "translate(-114 -81.49288)",
  fill: "#2f2e41"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M326.24093,763.43241s13.15653-1.97348,13.15653-1.31566,15.78782,43.41653,0,42.75871-75.65-9.20957-71.70306-24.9974,23.68174-11.183,23.68174-11.183l17.76131-9.8674Z",
  transform: "translate(-114 -81.49288)",
  fill: "#2f2e41"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M389.15532,585.029h38.856a135.90047,135.90047,0,0,0,0-46.32829h-38.856A83.36036,83.36036,0,0,1,389.15532,585.029Z",
  transform: "translate(-114 -81.49288)",
  fill: "#d0cde1"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M377.84,586.64548h38.856a135.90047,135.90047,0,0,0,0-46.32829H377.84A83.36036,83.36036,0,0,1,377.84,586.64548Z",
  transform: "translate(-114 -81.49288)",
  fill: "#6c63ff"
});

var _ref32 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 289.9948,
  cy: 159.5965,
  r: 30.27939,
  fill: "#ffb9b9"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M379.93417,237.25767s-5.386,53.85986-12.31082,57.707,53.09043,7.69426,53.09043,7.69426-14.61911-49.24329-10.00255-53.85985S379.93417,237.25767,379.93417,237.25767Z",
  transform: "translate(-114 -81.49288)",
  fill: "#ffb9b9"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M444.566,293.42581s-21.54394-20.77452-46.16559-16.92739-42.31846,8.46369-42.31846,8.46369-37.70189,20.00509-38.47132,36.16305,13.84968,76.94265,13.84968,76.94265,6.92483,99.256,7.69426,99.256S469.18764,495.785,469.18764,495.785L445.33542,366.52132Z",
  transform: "translate(-114 -81.49288)",
  fill: "#575a89"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439.53392,478.5729c-4.98587,1.3465-13.5803-.51555-22.55194-3.45472-16.00392-5.25519-33.20067-13.9574-33.20067-13.9574S328.3826,438.84741,312.22464,427.306s-5.386-57.707-5.386-57.707l24.62165,7.69426-1.53886,28.46878,60.78469,39.24075a137.1283,137.1283,0,0,1,28.138,5.65527c10.23341,3.36239,20.17434,8.60218,23.7675,16.6504a15.57442,15.57442,0,0,1,1.18495,3.85483C444.52749,475.41052,442.804,477.68034,439.53392,478.5729Z",
  transform: "translate(-114 -81.49288)",
  fill: "#ffb9b9"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M442.61162,467.30849c-1.06942,3.98562-2.10822,7.77889-3.0777,11.26441-4.98587,1.3465-13.5803-.51555-22.55194-3.45472l1.86214-24.46009C429.07753,454.02048,439.01846,459.26027,442.61162,467.30849Z",
  transform: "translate(-114 -81.49288)",
  opacity: 0.15
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M431.48575,354.97992l-4.61656,40.77961L419.21338,496.3792s-42.35691,50.95734-18.50469,52.49619,36.93247-50.01272,36.93247-50.01272,23.85222-81.5592,23.08279-98.48658,0-45.39617,0-45.39617Z",
  transform: "translate(-114 -81.49288)",
  fill: "#ffb9b9"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M438.18959,237.70987a7.89874,7.89874,0,0,0,2.17735-1.31169c1.653-1.60421,1.37431-4.32264.6565-6.51142s-1.76664-4.45167-1.25265-6.69706c.23951-1.04632.80972-2.0033.97261-3.06424.38733-2.52279-1.62537-4.82212-3.85311-6.0678s-4.79009-1.8593-6.89545-3.3022c-3.22878-2.21282-5.01158-6.11544-8.28954-8.25473-3.20561-2.09207-7.27871-2.15692-11.10659-2.15265l-11.42777.01273c-5.97215.00666-12.53483.22807-16.9796,4.21689-1.35192,1.21323-2.42269,2.71562-3.79178,3.90944-2.75738,2.40439-6.47891,3.36408-9.541,5.36607a16.54716,16.54716,0,0,0-7.34719,13.9347c.10813,5.07083,2.57974,9.99679,1.93755,15.028-.43079,3.375-2.25265,6.61792-1.774,9.9865.56759,3.99494,4.23214,6.85671,7.99018,8.326s7.85506,1.99689,11.51153,3.70334c2.98462,1.3929,6.1026,3.61314,9.24873,2.63846,2.66156-.82455,4.122-3.63548,5.07559-6.25359a51.03652,51.03652,0,0,0,2.44635-9.44241c.38291-2.40743.63683-4.95893,2.05063-6.94475a7.99622,7.99622,0,0,1,7.14982-3.08376c6.17064.54238,9.64424,11.05166,15.31882,8.56635,2.8138-1.23237,4.97576-4.92079,7.22955-6.93195A36.29747,36.29747,0,0,1,438.18959,237.70987Z",
  transform: "translate(-114 -81.49288)",
  fill: "#2f2e41"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M326.84375,314.20032s-15.38853,5.386-21.54394,26.92993-3.84714,36.163-3.84714,36.163l32.31592,5.386Z",
  transform: "translate(-114 -81.49288)",
  fill: "#575a89"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M429.17747,291.887s27.69935-6.15541,31.54648,20.00509a418.74285,418.74285,0,0,1,3.84714,53.09043s-26.1605-12.31083-37.7019,0Z",
  transform: "translate(-114 -81.49288)",
  fill: "#575a89"
});

var _ref41 =
/*#__PURE__*/
React.createElement("rect", {
  x: 387,
  y: 297,
  width: 27,
  height: 3,
  fill: "#f2f2f2"
});

var _ref42 =
/*#__PURE__*/
React.createElement("rect", {
  x: 60,
  y: 322,
  width: 27,
  height: 3,
  fill: "#f2f2f2"
});

var _ref43 =
/*#__PURE__*/
React.createElement("rect", {
  x: 387,
  y: 304,
  width: 27,
  height: 3,
  fill: "#f2f2f2"
});

var _ref44 =
/*#__PURE__*/
React.createElement("rect", {
  x: 764,
  y: 169,
  width: 27,
  height: 3,
  fill: "#f2f2f2"
});

var _ref45 =
/*#__PURE__*/
React.createElement("rect", {
  x: 764,
  y: 183,
  width: 27,
  height: 3,
  fill: "#f2f2f2"
});

var _ref46 =
/*#__PURE__*/
React.createElement("rect", {
  x: 764,
  y: 176,
  width: 27,
  height: 3,
  fill: "#f2f2f2"
});

var SvgUndrawMasterPlan95Wa = function SvgUndrawMasterPlan95Wa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "a12144e9-3c86-4872-a88a-b0ed4a062895",
    "data-name": "Layer 1",
    width: 972,
    height: 737.01423,
    viewBox: "0 0 972 737.01423",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawMasterPlan95Wa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_master_plan_95wa.5197514e.svg";
export { ForwardRef as ReactComponent };